<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box lite_backup_files">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ files.length }} {{ $t('language.common.transferFiles') }} ( {{ formatBytes(totalSize) }} )</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="show = false"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <!-- 表格 -->
                <el-table class="lite_backup_files_table" ref="fileTable" :data="pagedFiles" border highlight-current-row height="550px" empty-text=" ">
                    <el-table-column type="index" width="50px"></el-table-column>
                    <el-table-column label="Path" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{ scope.row.path }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Name" show-overflow-tooltip width="350px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Size" width="100px">
                        <template slot-scope="scope">
                            <span>{{ formatBytes(scope.row.size) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <div style="text-align: center; margin-top: 20px;">
                    <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="files.length"
                        :page-size="pageSize"
                        :current-page="currentPage"
                        @current-change="handlePageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        files: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            show: false,
            pageSize: 500,
            currentPage: 1,
        };
    },
    watch: {
        files() {
            this.currentPage = 1;
        }
    },
    computed: {
        pagedFiles() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.files.slice(start, end);
        },
        totalSize() {
            return this.files.reduce((total, file) => {
                const size = Number(file.size);
                if (!isNaN(size) && size > 0) {
                    return total + size;
                }
                return total;
            }, 0);
        },
    },
    methods: {
        handlePageChange(page) {
            this.currentPage = page;
            this.$nextTick(() => {
                this.scrollToTop();
            });
        },
        scrollToTop() {
            const table = this.$refs.fileTable;
            if (!table) return;
            // Element UI 表格内部滚动容器
            const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
            if (bodyWrapper) {
                bodyWrapper.scrollTop = 0;
            }
        },
        // 格式化字节数
        formatBytes(value) {
            if (value === null || value === undefined) return '-';
            if (value === 0) return '0B';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
            const i = Math.floor(Math.log(value) / Math.log(k));
            return (value / Math.pow(k, i)).toFixed(2) + sizes[i];
        },
    },
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box.lite_backup_files {
    width: 1200px;
}
/* 弹窗高度 */
.lite_backup_files>.lite_popup_content {
    height: 600px;
}
/* 表格 */
.lite_backup_files_table.el-table .el-table__cell {
    padding: 5px 0px;
}
/* 分页 */
.lite_backup_files .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #5562B4;
}
/* 分页文字 */
.lite_backup_files .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #7d87c8;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_backup_files.vue